import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PermissionsService } from '../services/permissions.service';

/**
 * Adds the selected `tenant` (country) header to every backend request, mirroring {@link LicenseInterceptor}.
 *
 * The backend uses this header to resolve which MongoDB database to operate against
 * (`rgs_data_<tenant>`). When no tenant is selected the request is forwarded unchanged and the
 * backend falls back to the JWT `tenant` claim (or its `nl` default).
 */
@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(private permissionsService: PermissionsService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    for (let index = 0; index < environment.excludeUrls.length; index++) {
      const excludeUrl = environment.excludeUrls[index];
      if (req.url.includes(excludeUrl)) {
        return next.handle(req);
      }
    }

    if (!this.permissionsService.tenant) {
      return next.handle(req);
    }

    const requestWithTenant = req.clone({
      headers: req.headers.set('tenant', this.permissionsService.tenant),
    });

    return next.handle(requestWithTenant);
  }
}
